import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;
const TIMEOUT_MS = 10000;

const createAxiosInstance = () => {
  const bearerToken = localStorage.getItem('ICEMAKE');
  const instance = axios.create({
    baseURL,
    timeout: TIMEOUT_MS,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    },
  });

  // Add a response interceptor
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      // Handle specific error response
      if (error.response) {
        const { status, data } = error.response;
        const token = localStorage.getItem('ICEMAKE');
        const userRole = localStorage.getItem('role');

        if (data.success === false && data.errorCode === '401' && token) {
          localStorage.clear();
          // Use navigate to redirect to the login page
          if (userRole == 'dealer') {
            window.location.href = '/dealerlogin';
          } else {
            window.location.href = '/login';
          }
        }
      }
      return Promise.reject(error); // Always reject the error
    },
  );

  return instance;
};

export default createAxiosInstance;
